import { P360Card } from 'legacy/lut/components/widgets/public/partner360/p360Card'

import { Translation } from 'cng-common/features/translations'

import { scoreCards } from '../../configs/config'
import { TRANSLATION_KEYS } from '../../configs/translations'
import { ScoreCard } from '../common/scoreCard/ScoreCard'

import styles from './Requirements.module.scss'

export const RequirementsOverview = () => (
  <>
    <div className={styles.intro}>
      <Translation htmlAvailable text={TRANSLATION_KEYS.requirements.intro} />
    </div>

    <section className={styles.section}>
      <div className={styles.sectionTitle}>
        <Translation text={TRANSLATION_KEYS.requirements.whatWeScore} />
      </div>

      <div className={styles.scoreGrid}>
        {scoreCards.map((card, index) => (
          <P360Card key={index}>
            <ScoreCard scoreCard={card} number={index + 1} />
          </P360Card>
        ))}
      </div>
    </section>
  </>
)
